import { spawn } from 'redux-saga/effects';

import cartAdminQuoteSagas from './quote/sagas';

export default function* sagas() {
	yield spawn(cartAdminQuoteSagas);
}
